export default __webpack_public_path__ + "4fcb433bafc3f1b55fcb3855ad55af1d.png";